import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "regenerator-runtime/runtime.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { postReq, getReq, putReq } from './axios';
import { creditBody, creditModel, getCreditModel, allCreditsParams, documentParams, creditPaymentModel } from './models';
var BASE_URL = "".concat(apiUrl, "/credit");
export var createCredit = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(body) {
    var _yield$postReq, _yield$postReq2, res, err;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return postReq(BASE_URL, creditBody(body));

          case 2:
            _yield$postReq = _context.sent;
            _yield$postReq2 = _slicedToArray(_yield$postReq, 2);
            res = _yield$postReq2[0];
            err = _yield$postReq2[1];
            return _context.abrupt("return", [res && creditModel(res), err]);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createCredit(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var refinanceCredit = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(body) {
    var _yield$postReq3, _yield$postReq4, res, err;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return postReq("".concat(BASE_URL, "/refinance"), creditBody(body));

          case 2:
            _yield$postReq3 = _context2.sent;
            _yield$postReq4 = _slicedToArray(_yield$postReq3, 2);
            res = _yield$postReq4[0];
            err = _yield$postReq4[1];
            return _context2.abrupt("return", [res && creditModel(res), err]);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function refinanceCredit(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var previewCredit = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(body) {
    var _yield$postReq5, _yield$postReq6, res, err;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return postReq("".concat(BASE_URL, "/preview"), creditBody(body));

          case 2:
            _yield$postReq5 = _context3.sent;
            _yield$postReq6 = _slicedToArray(_yield$postReq5, 2);
            res = _yield$postReq6[0];
            err = _yield$postReq6[1];
            return _context3.abrupt("return", [res && creditModel(res), err]);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function previewCredit(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var getCredit = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
    var _yield$getReq, _yield$getReq2, res, err;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getReq("".concat(BASE_URL, "/").concat(id));

          case 2:
            _yield$getReq = _context4.sent;
            _yield$getReq2 = _slicedToArray(_yield$getReq, 2);
            res = _yield$getReq2[0];
            err = _yield$getReq2[1];
            return _context4.abrupt("return", [res && getCreditModel(res), err]);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getCredit(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var getAllCredits = function getAllCredits(params) {
  return getReq(BASE_URL, {
    params: allCreditsParams(params)
  });
};
export var exportAllCredits = function exportAllCredits(params) {
  return getReq("".concat(BASE_URL, "/export"), {
    params: allCreditsParams(params),
    responseType: 'blob'
  });
};
export var getAllCreditsDropdown = function getAllCreditsDropdown() {
  return getReq("".concat(BASE_URL, "/all"));
};
export var changeCreditStatus = function changeCreditStatus(id, body) {
  return putReq("".concat(BASE_URL, "/").concat(id, "/change-status"), body);
};
export var getDocumentTypesForCredit = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(creditId) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", getReq("".concat(BASE_URL, "/").concat(creditId, "/getSignTypes")));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getDocumentTypesForCredit(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
export var getSignTypesAfterApproval = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(creditId) {
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", getReq("".concat(BASE_URL, "/").concat(creditId, "/getSignTypesAfterApproval")));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getSignTypesAfterApproval(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
export var getDocumentForCredit = function getDocumentForCredit(creditId, params) {
  return getReq("".concat(BASE_URL, "/").concat(creditId, "/getPreparedDocumentPDF"), {
    params: documentParams(params),
    responseType: 'arraybuffer'
  });
};
export var geSignetDocumentForCredit = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(creditId, params) {
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", getReq("".concat(BASE_URL, "/").concat(creditId, "/getDocumentForCredit"), {
              params: documentParams(params),
              responseType: 'arraybuffer'
            }));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function geSignetDocumentForCredit(_x7, _x8) {
    return _ref7.apply(this, arguments);
  };
}();
export var signDocumentForCredit = function signDocumentForCredit(id, body, params) {
  return postReq("".concat(BASE_URL, "/").concat(id, "/signDocumentForCredit"), body, {
    params: documentParams(params),
    responseType: 'arraybuffer'
  });
};
export var getCreditPaymentPreview = function getCreditPaymentPreview(id, params) {
  return getReq("".concat(BASE_URL, "/").concat(id, "/paymentPreview"), {
    params: creditPaymentModel(params)
  });
};
export var postCreditPayment = function postCreditPayment(id, body) {
  return postReq("".concat(BASE_URL, "/").concat(id, "/addPayment"), creditPaymentModel(body), {
    responseType: 'arraybuffer'
  });
};
export var postCreditFullEarlyRepayment = function postCreditFullEarlyRepayment(id, body) {
  return postReq("".concat(BASE_URL, "/").concat(id, "/fullEarlyRepayment"), body, {
    responseType: 'arraybuffer'
  });
};
export var signPaymentDocument = function signPaymentDocument(id, body) {
  return postReq("".concat(BASE_URL, "/").concat(id, "/signPaymentDocument"), body, {
    responseType: 'arraybuffer'
  });
};
export var getCreditPayments = function getCreditPayments(id) {
  return getReq("".concat(BASE_URL, "/").concat(id, "/paymentList"));
};
export var getCreditRefinanceAmount = function getCreditRefinanceAmount(id) {
  return getReq("".concat(BASE_URL, "/").concat(id, "/totalAmountForRefinance"));
};
export var activateCredit = function activateCredit(id) {
  return putReq("".concat(BASE_URL, "/").concat(id, "/activate"));
};
export var addCreditGuarantor = function addCreditGuarantor(id, body) {
  return putReq("".concat(BASE_URL, "/").concat(id, "/add-guarantor"), body);
};
export var getCreditEarlyRepaymentAmount = function getCreditEarlyRepaymentAmount(id) {
  return getReq("".concat(BASE_URL, "/").concat(id, "/earlyRepaymentAmount"));
};
export var deletePaymentForCredit = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(creditId, paymentId) {
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", postReq("".concat(BASE_URL, "/").concat(creditId, "/deletePayment/").concat(paymentId)));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function deletePaymentForCredit(_x9, _x10) {
    return _ref8.apply(this, arguments);
  };
}();
export var getDocumentForEarlyRepayment = function getDocumentForEarlyRepayment(creditId) {
  return getReq("".concat(BASE_URL, "/").concat(creditId, "/getDocumentForEarlyRepayment"), {
    responseType: 'arraybuffer'
  });
};
export var getDocumentForAbsenceOrRefusal = function getDocumentForAbsenceOrRefusal(creditId) {
  return getReq("".concat(BASE_URL, "/").concat(creditId, "/getDocumentForAbsenceOrRefusal"), {
    responseType: 'arraybuffer'
  });
};